import { useState } from 'react';
import { AccountUser, TimezoneRequest } from 'vopay';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export default function useAccountUsers() {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<AccountUser[]>([]);

  async function fetchUsers(params: TimezoneRequest) {
    try {
      setLoading(true);
      const res = await api.fetchAccountUsers(params);
      setUsers(res.Users);
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    users,
    fetchUsers,
  };
}
